import { useState } from "react";
import ShellCard from "../../components/ShellCard";
import slide1Img from "@/assets/images/slide-1.jpg";
import PackageCard from "../../components/PackageCard";

const packages = [
    {
        id: 1,
        titleLines: ["Curso de Educación", "Vial para Conductores", "(DETS)"],
        price: "$34.95",
        description: (
            <>
                <p>
                    El curso de Educación Vial para Conductores (DETS) es obligatorio para obtener la licencia. (Solo para conductores nuevos de 14 a 17 años).
                </p>
            </>
        ),
        registerLink: "https://courses.metrotrafficschool.com/onlinecourses/registration/create_account?awc_id=MzIwNQ==",
    },
    {
        id: 2,
        titleLines: ["Examen de Práctica", "para el Permiso", "de Florida"],
        price: "$19.95",
        description: (
            <>
                <p>Examen de práctica para el permiso del DMV de Florida</p>
            </>
        ),
        infoLink: "prep-course",
        registerLink: "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=NTE1",
    },
    {
        id: 3,
        titleLines: ["Examen del", "Permiso de", "Florida"],
        price: "$24.95",
        description: (
            <>
                <p>Examen para el permiso de conducir de Florida</p>
            </>
        ),
        infoLink: "florida-driving-test",
        registerLink: "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=Mzg1",
    },
    {
        id: 4,
        titleLines: ["Paquete de", "Ahorro", ""],
        price: "$52.90",
        description: (
            <>
                <p>Curso de Educación Vial para Conductores (DETS) + Examen del Permiso del DMV de Florida</p>
                <p className="fw-bold text-warning">AHORRA $7.00 - 16%</p>
            </>
        ),
        registerLink: "https://courses.metrotrafficschool.com/onlinecourses/registration/create_account?awc_id=MzIwNg==",
    },
    {
        id: 5,
        titleLines: ["Paquete Completo", "con el Examen de Práctica"],
        price: "$64.90",
        description: (
            <>
                <p>Curso de Educación Vial para Conductores (DETS) + Examen de práctica del permiso + Examen del permiso del DMV de Florida</p>
                <p className="fw-bold text-warning">AHORRA $14.95 - 25%</p>
            </>
        ),
        registerLink: "http://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=MzIwOA==",
    },
];

const DetsCourseEs = () => {
    const [hoveredCardId, setHoveredCardId] = useState(null);

    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${slide1Img})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title mb-2">Curso de Educación Vial para Conductores (DETS)</h1>
                            <p className="banner-subheading fs-4">
                                Efectiva a partir del 1 de julio de 2025
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <main className="dets-course-page text-white">
                <div className="container py-5">
                    <div className="row justify-content-center mb-5">
                        <div className="col-12">
                            <ShellCard>
                                <h3 className="section-title mb-4 text-warning">Detalles del Curso</h3>
                                <p className="mb-4">
                                    El nuevo curso obligatorio para conductores principiantes de 14 a 17 años se llama Curso de Educación Vial para Conductores (DETS). Eres un adolescente o conductor principiante en Florida listo para salir a la carretera? Nuestro curso en línea de educación vial en la Florida, aprobado por el estado, es la manera más fácil, rápida y flexible de cumplir con los requisitos para obtener tu permiso de aprendizaje, ¡sin poner un pie en un salón de clases!.
                                </p>

                                <h4 className="section-title mb-4 text-warning">Por qué elegir nuestro curso en línea?</h4>
                                <ul className="text-white ps-3" style={{ listStyleType: 'disc' }}>
                                    <li className="mb-2">Aprobado por el DHSMV de Florida</li>
                                    <li className="mb-2">Disponible las 24 horas, los 7 días de la semana, en cualquier dispositivo - estudia a tu propio ritmo</li>
                                    <li className="mb-2">Lecciones interactivas, videos y cuestionarios para mantener tu interés</li>
                                    <li className="mb-2">Seguimiento automático de tu progreso – continúa justo donde te quedaste</li>
                                    <li className="mb-2">Certificado de finalización enviado directamente a las oficinas del DMV</li>
                                    <li className="mb-2">Excelente servicio de atención al cliente si necesitas ayuda</li>
                                </ul>
                            </ShellCard>
                        </div>
                    </div>

                    <div className="row g-4 justify-content-center mb-5">
                        {packages.map((pkg) => (
                            <div key={pkg.id} className="col-12 col-md-6 col-lg-4 col-xl-2-4" style={{ minWidth: '220px' }}>
                                <PackageCard
                                    pkg={pkg}
                                    hoveredCardId={hoveredCardId}
                                    setHoveredCardId={setHoveredCardId}
                                    registerText="Registrese"
                                    moreInfoText="(Más información)"
                                />
                            </div>
                        ))}
                    </div>

                    <div className="row mb-5">
                        <div className="col-12">
                            <ShellCard>
                                <h3 className="section-title mb-4 text-warning">Preguntas Frecuentes (FAQ)</h3>
                                <div className="accordion" id="faqAccordion">
                                    <div className="accordion-item bg-accordion border-secondary text-white">
                                        <h2 className="accordion-header" id="headingOne">
                                            <button className="accordion-button bg-accordion text-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                Quiénes deben tomar este nuevo curso de educación vial?
                                            </button>
                                        </h2>
                                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                Todos los conductores nuevos en el estado de Florida de 14, 15, 16 o 17 años deben tomar el nuevo curso Driver Education Traffic Safety (DETS).
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item bg-accordion border-secondary text-white">
                                        <h2 className="accordion-header" id="headingTwo">
                                            <button className="accordion-button collapsed bg-accordion text-white border-bottom border-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                Todavía necesito tomar el curso de 4 horas para conductores primerizos (TLSAE)?
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                No. El curso de 4 horas para conductores primerizos (TLSAE) es solo para conductores nuevos de 18 años o más.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item bg-accordion border-secondary text-white">
                                        <h2 className="accordion-header" id="headingThree">
                                            <button className="accordion-button collapsed bg-accordion text-white border-bottom border-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                El curso se ofrece en línea?
                                            </button>
                                        </h2>
                                        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                Sí, el curso está disponible 100% en línea para que estudies a tu propio ritmo.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item bg-accordion border-secondary text-white">
                                        <h2 className="accordion-header" id="headingFour">
                                            <button className="accordion-button collapsed bg-accordion text-white border-bottom border-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                Cuando finalice el curso, ¿todo se reporta a las oficinas del DMV?
                                            </button>
                                        </h2>
                                        <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                Sí, tu certificado de finalización se envía automáticamente de forma electrónica a las oficinas del DMV.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ShellCard>
                        </div>
                    </div>

                    {/* Who Needs This Course, What's Included, How It Works */}
                    <div className="row g-4">
                        <div className="col-12">
                            <ShellCard>
                                <div className="mb-4">
                                    <h4 className="section-title text-warning">Quién necesita este curso?</h4>
                                    <p>
                                        Si tienes 14, 15, 16 o 17 años en Florida, debes completar el curso Driver Education Traffic Safety (DETS) antes de poder obtener tu permiso de aprendizaje.
                                    </p>
                                    <p className="fw-bold">
                                        A partir del 1 de julio de 2025, todos los conductores nuevos de 14 a 17 años deberán tomar este curso.
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h4 className="section-title text-warning">Qué incluye el curso?</h4>
                                    <p>El Departamento de Educación de Florida (DOE) ha indicado que los temas incluyen:</p>
                                    <ul className="text-white ps-3" style={{ listStyleType: 'disc' }}>
                                        <li>Significado y responsabilidades de una licencia de conducir</li>
                                        <li>Leyes que regulan la operación de un vehículo motorizado</li>
                                        <li>Conocimiento de las leyes de Licencia Graduada de Florida (GDL)</li>
                                        <li>Control del vehículo y procedimientos de tránsito</li>
                                        <li>Convivencia en la vía con otros vehículos y usuarios vulnerables</li>
                                        <li>Estrategias de manejo defensivo</li>
                                        <li>Factores físicos y mentales que afectan la capacidad de conducción</li>
                                        <li>Efectos del alcohol y otras drogas en el desempeño al conducir</li>
                                    </ul>
                                </div>

                                <div className="mb-4">
                                    <h4 className="section-title text-warning">Cómo funciona</h4>
                                    <ol className="text-white ps-3" style={{ listStyleType: 'decimal' }}>
                                        <li>Regístrate en solo unos minutos</li>
                                        <li>Completa el curso a tu propio ritmo</li>
                                        <li>Pasa el examen final - con repeticiones ilimitadas y gratis si lo necesitas</li>
                                        <li>Recibe tu certificado - enviado automáticamente al DMV</li>
                                    </ol>
                                </div>

                                <div className="text-start mb-4">
                                    <h4 className="section-title text-warning">Conduce con confianza</h4>
                                    <p>
                                        Hacemos que la educación vial sea simple, conveniente y económica. Si eres un adolescente que busca su permiso de aprendizaje o un adulto que necesita un repaso, nuestro curso está diseñado para ponerte al volante de forma segura, legal, y rápida.
                                    </p>
                                </div>
                                <div className="row text-center">
                                    <div className="col-12">
                                        <h5 className="fw-bold text-warning mt-4">Regístrate hoy y comienza tu camino hacia la libertad de conducir!</h5>

                                        <a href="https://courses.metrotrafficschool.com/onlinecourses/registration/create_account?awc_id=MzIxNw==" target="_blank" rel="noopener noreferrer" className="my-3 btn metro-btn-primary btn-lg fw-bold">Regístrate Ahora</a>
                                        <p className="mt-2 text-white">Solo toma unos minutos para comenzar!</p>
                                    </div>
                                </div>
                            </ShellCard>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default DetsCourseEs;
